export const customerTypeDescriptions = {
  consumer: 'Consumers (B2C)',
  organisation: 'Businesses (B2B)',
};
